import {
    FormControl,
    FormControlLabel,
    Paper,
    Radio,
    RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../components/withRouter";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import ReportingConfiguration from "./ReportingConfiguration";
import ReportingManagerList from "./ReportingManagerList";

class ReportingConfigurationMain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: "0",
            stockData: [],
        };
    }
    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        });
    };

    onCancel = () => {
        this.props.navigate(-1);
    };
    render() {
        const { value, stockData } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <LandingScreenHeader
                        screenTitle={"Reporting Configuration"}
                        showTable={false}
                        showBackButton={true}
                        showAddButton={false}
                        onCancel={this.onCancel}
                    />
                    <br />
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={value}
                            onChange={this.handleChange}
                            row
                            defaultValue={value}
                        >
                            <FormControlLabel
                                value="0"
                                control={<Radio />}
                                label="Reporting Type Assignation"
                            />
                            <FormControlLabel
                                value="1"
                                control={<Radio />}
                                label="Reporting Summary"
                            />
                        </RadioGroup>

                    </FormControl>

                    {value === "0" && <ReportingConfiguration value={value} />}
                    {value === "1" && <ReportingManagerList value={value} />}

                </Paper >
            </>
        );
    }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    showLoador,
    showNotification,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ReportingConfigurationMain);
